import series from "./series/series"
import xAxis from "./xAxis/xAxis"
import yAxis from "./yAxis/yAxis"
import color from "./color/color"
import backgroundColor from "./backgroundColor"
import grid from "./grid/grid"
import legend from "./legend/legend"
import title from "./title/title"
import tooltip from "./tooltip/tooltip"

export default {
  series,
  xAxis,
  yAxis,
  color,
  backgroundColor,
  grid,
  legend,
  title,
  tooltip,
}
